import { serializable } from 'serializr';
export class AddressModel {
  @serializable
  id?: number;

  @serializable
  city?: string;

  @serializable
  street?: string;

  @serializable
  province?: string;

  @serializable
  postal_code?: string;

  @serializable
  country?: string;

  @serializable
  country_code?: string;

  @serializable
  latitude?: string;

  @serializable
  longitude?: string;

  getFullAddress(): string {
    return `${this.city || ''}, ${this.country || ''}, ${
      this.postal_code || ''
    }`;
  }
}
